import { useSetAtom } from "jotai";
import { draftReturnAtomFamily } from "../atoms/draft-return.atom";
import { setReturnMode } from "../lib/draft.lib";
import type { ReturnMode } from "../types";

export function useSetReturnMode(orderId: string) {
  const setDraft = useSetAtom(draftReturnAtomFamily(orderId));

  return (
    returnMode: ReturnMode,
    storeId: string | null = null,
    pickupDate: string | null = null,
  ) => {
    setDraft((draft) =>
      draft ? setReturnMode(draft, returnMode, storeId, pickupDate) : draft,
    );
  };
}
